import React from 'react';
import { ChevronRight } from 'lucide-react';
import { twMerge } from 'tailwind-merge';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'link';
  children: React.ReactNode;
  className?: string;
  showChevron?: boolean;
}
export function Button({
  variant = 'primary',
  children,
  className,
  showChevron = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-6 py-3 rounded-full font-medium transition-colors duration-200';
  const variants = {
    primary: 'bg-copper text-white hover:bg-copper-600',
    secondary: 'bg-transparent border-2 border-copper text-copper hover:bg-copper-50',
    link: 'bg-transparent text-copper hover:text-copper-600 px-0 py-0'
  };
  return <button className={twMerge(baseStyles, variants[variant], className)} {...props} data-id="element-11">
      {children}
      {showChevron && <ChevronRight className="ml-2 w-4 h-4" data-id="element-12" />}
    </button>;
}